'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formsReducer = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _startsWith = require('lodash/startsWith');

var _startsWith2 = _interopRequireDefault(_startsWith);

var _cloneDeep = require('lodash/cloneDeep');

var _cloneDeep2 = _interopRequireDefault(_cloneDeep);

var _some = require('lodash/some');

var _some2 = _interopRequireDefault(_some);

var _every = require('lodash/every');

var _every2 = _interopRequireDefault(_every);

var _get = require('lodash/get');

var _get2 = _interopRequireDefault(_get);

var _set = require('lodash/set');

var _set2 = _interopRequireDefault(_set);

var _actions = require('./actions');

var actions = _interopRequireWildcard(_actions);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var initialFormState = {
  fields: {},
  model: {},
  valid: true
};

var initialFieldState = {
  value: null,
  focused: false,
  touched: false,
  changed: false,
  validated: false,
  valid: true,
  errors: {}
};

var setModel = function setModel(model, path, value) {
  return path ? (0, _set2.default)((0, _cloneDeep2.default)(model), path, value) : value;
};

var mapFields = function mapFields(fields, fieldPath, mapOptions) {
  if (fields[fieldPath]) {
    fields[fieldPath] = Object.assign({}, fields[fieldPath], mapOptions(fieldPath, fields[fieldPath]));
  } else {
    Object.keys(fields).forEach(function (key) {
      if ((0, _startsWith2.default)(key, fieldPath)) {
        fields[key] = Object.assign({}, fields[key], mapOptions(key, fields[key]));
      }
    });
  }

  return fields;
};

var formsReducer = exports.formsReducer = function formsReducer(formKeys) {
  var initialState = (formKeys || []).reduce(function (obj, key) {
    obj[key] = Object.assign({}, initialFormState);
    return obj;
  }, {});

  return function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
    var action = arguments[1];

    if (!(action.type || '').startsWith('abyss/form')) {
      return state;
    }

    var _action$payload = action.payload,
        model = _action$payload.model,
        value = _action$payload.value,
        options = _action$payload.options;


    var modelKeys = (model || '').split('.');
    var formKey = modelKeys[0];
    var fieldPath = modelKeys.slice(1).join('.');
    var formState = state[formKey];

    if (!formState) {
      console.error('Abyss-Form: Form key \'' + formKey + '\' missing in \'forms\' reducer.');
      return state;
    }

    switch (action.type) {

      case actions.SUBMIT:
        {
          var newFields = Object.assign({}, formState.fields);
          var mappedFields = mapFields(newFields, fieldPath, function (key, field) {
            return _extends({
              focused: key === action.payload.focus,
              touched: field.validated,
              changed: field.validated
            }, options);
          });

          return _extends({}, state, _defineProperty({}, formKey, _extends({}, formState, {
            fields: mappedFields
          })));
        }

      case actions.SET:
        {
          var newModel = setModel(formState.model, fieldPath, value);
          var _newFields = Object.assign({}, formState.fields);

          var mappedValue = void 0;

          if (_newFields[fieldPath]) {
            mappedValue = { value: value };
          }

          var _mappedFields = mapFields(_newFields, fieldPath, function () {
            return _extends({}, mappedValue, {
              changed: true,
              valid: !options.errors || !(0, _some2.default)(options.errors),
              validated: !!options.errors
            }, options);
          });

          return _extends({}, state, _defineProperty({}, formKey, {
            fields: _mappedFields,
            model: newModel,
            valid: (0, _every2.default)(_mappedFields, function (field) {
              return field.valid;
            })
          }));
        }

      case actions.UPDATE:
        {
          var _newFields2 = Object.assign({}, formState.fields);
          var _mappedFields2 = mapFields(_newFields2, fieldPath, function () {
            return options;
          });

          return _extends({}, state, _defineProperty({}, formKey, _extends({}, formState, {
            fields: _mappedFields2,
            valid: (0, _every2.default)(_mappedFields2, function (field) {
              return field.valid;
            })
          })));
        }

      case actions.RESET:
        {
          var resetValue = value || (fieldPath ? null : {});
          var _newModel = setModel(formState.model, fieldPath, resetValue);
          var _newFields3 = Object.assign({}, formState.fields);
          var _mappedFields3 = mapFields(_newFields3, fieldPath, function () {
            return _extends({}, initialFieldState, options);
          });

          return _extends({}, state, _defineProperty({}, formKey, _extends({}, formState, {
            fields: _mappedFields3,
            model: _newModel
          })));
        }

      case actions.UNSET:
        {
          var _newFields4 = Object.assign({}, formState.fields);
          delete _newFields4[fieldPath];

          return _extends({}, state, _defineProperty({}, formKey, _extends({}, formState, {
            fields: _newFields4,
            valid: (0, _every2.default)(_newFields4, function (field) {
              return field.valid;
            })
          })));
        }

      case actions.VALIDATE:
        {
          var _newModel2 = setModel(formState.model, fieldPath, value);
          var _newFields5 = Object.assign({}, formState.fields);

          if (!_newFields5[fieldPath] && fieldPath) {
            _newFields5[fieldPath] = Object.assign({}, initialFieldState);
          }

          var _mappedValue = void 0;

          if (_newFields5[fieldPath]) {
            _mappedValue = { value: value };
          }

          var _mappedFields4 = mapFields(_newFields5, fieldPath, function () {
            return _extends({}, _mappedValue, {
              valid: !options.errors || !(0, _some2.default)(options.errors),
              validated: true
            }, options);
          });

          return _extends({}, state, _defineProperty({}, formKey, {
            fields: _mappedFields4,
            model: _newModel2,
            valid: (0, _every2.default)(_mappedFields4, function (field) {
              return field.valid;
            })
          }));
        }

      case actions.ADD_ITEM:
        {
          var values = (0, _get2.default)(formState.model, fieldPath, []).slice();
          var index = action.payload.index;
          var addIndex = index >= 0 ? index + 1 : values.length;
          values.splice(addIndex, 0, value);
          var _newModel3 = setModel(formState.model, fieldPath, values);

          return _extends({}, state, _defineProperty({}, formKey, _extends({}, formState, {
            model: _newModel3
          })));
        }

      case actions.REMOVE_ITEM:
        {
          var _values = (0, _get2.default)(formState.model, fieldPath, []);
          var _index = action.payload.index;
          var removeIndex = _index >= 0 ? _index : _values.length - 1;
          var newValues = _values.filter(function (v, i) {
            return i !== removeIndex;
          });
          var _newModel4 = setModel(formState.model, fieldPath, newValues);

          return _extends({}, state, _defineProperty({}, formKey, _extends({}, formState, {
            model: _newModel4
          })));
        }

    }

    return state;
  };
};

exports.default = formsReducer;


//////////////////
// WEBPACK FOOTER
// ./node_modules/abyss-form/lib/reducer.js
// module id = 648
// module chunks = 0